import React from "react";
import { useTranslation } from "react-i18next";
import { Translate } from "@phosphor-icons/react";

const LANGS = [
  { code: "fr", label: "FR", fullLabelKey: "common.language_fr" },
  { code: "en", label: "EN", fullLabelKey: "common.language_en" },
  { code: "ln", label: "LN", fullLabelKey: "common.language_ln" },
  { code: "sw", label: "SW", fullLabelKey: "common.language_sw" },
];

export default function LanguageSwitcher({ className = "", full = false }) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || "fr").slice(0, 2);

  const changeLanguage = async (code) => {
    localStorage.setItem("i18nextLng", code);
    document.documentElement.lang = code;
    await i18n.changeLanguage(code);
  };

  return (
    <div
      className={`language-switcher inline-flex max-w-full items-center gap-1 overflow-x-auto rounded-full border border-white/10 bg-white/5 p-1 ${className}`}
      data-testid="language-switcher"
    >
      <Translate size={14} weight="bold" className="ml-2 shrink-0 text-muted-foreground" />
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            onClick={() => changeLanguage(l.code)}
            className={`shrink-0 whitespace-nowrap rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest transition-all press-down ${
              active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`lang-${l.code}`}
          >
            {full ? t(l.fullLabelKey) : l.label}
          </button>
        );
      })}
    </div>
  );
}
